import * as Styled from './styled'
import { FuelIcon, FuelTypography, FuelButton } from '@frete.com/fuel-react'
import { dsTokens } from 'ds'
import { useTranslator } from '~hooks'
import { Text } from '~constants/text'
import { Props } from './interfaces'

function FeedbackPurchaseUsersSuccess({ onSuccess, amount }: Props) {
  const { translate } = useTranslator()

  return (
    <Styled.Wrapper>
      <Styled.IconWrapper>
        <FuelIcon name="one-check" size="medium" iconStyle="outlined" />
      </Styled.IconWrapper>
      <FuelTypography
        size='body-lg'
        weight='bold'
        spacingTop={parseFloat(dsTokens.spacing.km8)}
      >
        {translate(Text.EXTRA_USERS_PURCHASE_SUCCESS)}
      </FuelTypography>
      <div style={{ color: dsTokens.color.text.neutral.default}}>
        <FuelTypography
          size='body-sm'
          color='inherit'
          spacingTop={parseFloat(dsTokens.spacing.km4)}>
          {translate(Text.YOU_GOT_USERS_TO_REGISTER, { amount: `${amount}`, plural: amount > 1 ? 's' : '' })}
        </FuelTypography>
      </div>

      <FuelButton
        size="large"
        style={{ marginTop: parseFloat(dsTokens.spacing.km8) }}
        onClick={onSuccess}
      >
        {translate(Text.REGISTER_NEW_USERS)}
      </FuelButton>
    </Styled.Wrapper>
  )
}

export default FeedbackPurchaseUsersSuccess
